import { useLocation, useNavigate } from "react-router-dom";
import "./Navigation.css";

const navItems = [
  { label: "Home", id: "home" },
  { label: "About", id: "about" },
  { label: "Services", id: "services" },
  { label: "Projects", id: "projects" },
  { label: "Contact", id: "contact" },
];

function Navigation() {
  const location = useLocation();
  const navigate = useNavigate();

  const isQuotePage = location.pathname.toLowerCase() === "/quote";

  const scrollToSection = (id) => {
    const section = document.getElementById(id);

    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
    }
  };

  const handleNavClick = (e, id) => {
    e.preventDefault();

    if (isQuotePage) {
      navigate("/");

      setTimeout(() => {
        scrollToSection(id);
      }, 100);
    } else {
      scrollToSection(id);
    }
  };

  const handleQuoteButton = (e) => {
    e.preventDefault();

    if (isQuotePage) {
      const estimationSection = document.getElementById("estimation");

      if (estimationSection) {
        estimationSection.scrollIntoView({ behavior: "smooth" });
      }
    } else {
      navigate("/quote");
    }
  };

  return (
    <header className="site-header">
      <a
        className="brand"
        href="#home"
        onClick={(e) => {
          e.preventDefault();
          isQuotePage ? navigate("/") : scrollToSection("home");
        }}
      >
        <img
          className="brand-logo"
          src="/logo/company logo.jpeg"
          alt="Sarathi Constructions logo"
        />
        <span>Sarrathi Constructions</span>
      </a>

      <nav className="nav-links">
        {navItems.map((item) => (
          <a
            key={item.id}
            href={`#${item.id}`}
            onClick={(e) => handleNavClick(e, item.id)}
          >
            {item.label}
          </a>
        ))}
      </nav>

      <a
        className="contact-pill"
        href={isQuotePage ? "#estimation" : "/quote"}
        onClick={handleQuoteButton}
      >
        {isQuotePage ? "Move To Estimation" : "Get Your Quote"}
      </a>
    </header>
  );
}

export default Navigation;
